window.guardarPlantillaPubli = () => {
    const nombre = $("#nueva-plantilla").val().trim();

    if (!nombre) {
        alert("El nombre de la plantilla es obligatorio");
        return;
    }

    $.ajax({
        url: "/guardar-plantilla-publi",
        type: "POST",
        data: {
            nombre: nombre,
            _token: $('meta[name="csrf-token"]').attr("content"),
        },
        success: function (response) {
            $("#nueva-plantilla").val("");
            closetooltip("modalAddPlantillaBO");
            window.location.reload();
        },
        error: function (xhr) {
            alert("Error al crear la plantilla");
            console.error(xhr.responseText);
        },
    });
};

window.guardarPlantillaMail = (modo = "crear") => {
    const isEditar = modo === "editar";

    const id = isEditar ? $("#editar-plantilla-id").val() : null;

    const nombre = isEditar
        ? $("#editar-nombre-plantilla-email").val().trim()
        : $("#crear-nombre-plantilla-email").val().trim();

    const descripcion = isEditar
        ? $("#editar-descripcion-plantilla-email").val().trim()
        : $("#crear-descripcion-plantilla-email").val().trim();

    const asunto = isEditar
        ? $("#editar-asunto-plantilla-email").val().trim()
        : $("#crear-asunto-plantilla-email").val().trim();

    const to = isEditar
        ? $("#editar-to-plantilla-email").val().trim()
        : $("#crear-to-plantilla-email").val().trim();

    const mail_account_id = isEditar
        ? $("#editar-mail-account-id").val().trim()
        : $("#crear-mail-account-id").val().trim();

    if (!nombre || !asunto || !to) {
        alert("Rellene todos los campos");
        return;
    }

    $.ajax({
        url: "/guardar-plantilla-mail",
        type: "POST",
        data: {
            name: nombre,
            id: id,
            descripcion: descripcion,
            asunto: asunto,
            emails: to,
            mail_account_id,
            _token: $('meta[name="csrf-token"]').attr("content"),
        },
        success: function () {
            closetooltip(
                isEditar
                    ? "modalEditarPlantillaMail"
                    : "modalAddPlantillaEmailBO",
            );
            window.location.reload();
        },
        error: function (xhr) {
            alert("Error al guardar la plantilla");
            console.error(xhr.responseText);
        },
    });
};

window.copiarUrl = (src) => {
    const bladeImg = `{!! '<img src="${src}" style="width:250px;">' !!}`;

    navigator.clipboard
        .writeText(bladeImg)
        .then(() => {
            console.log("Blade IMG copiada:", bladeImg);
        })
        .catch((err) => {
            console.error("Error al copiar", err);
        });
};

window.eliminarImagen = (nombre) => {
    if (!confirm("¿Eliminar imagen?")) return;

    fetch("/plantillas/mails/imagenes/delete", {
        method: "POST",
        headers: {
            "X-CSRF-TOKEN": "{{ csrf_token() }}",
            "Content-Type": "application/json",
        },
        body: JSON.stringify({ nombre }),
    }).then(() => location.reload());
};
